import React, { FC } from 'react';
import { Spin, Space } from 'antd';

const Spinner: FC = () => (
  <Space align="center" direction="vertical" style={{ display: 'flex' }}>
    <Spin />
  </Space>
);

export default Spinner;
